//import axios from "axios";
import axios from "../utils/axiosConfig";
import { IUpdateItemResponse } from "../Interfaces/IInventory";
import { IUserRequest } from "../Interfaces/IUser";
const { BASE_URL } = require("../utils/urls");

//const API_BASE_URL = "https://panaccoapi-453601304730.asia-south1.run.app"; // Replace with your actual API endpoint
//const API_BASE_URL = "http://localhost:8080";
export interface UserPayload {
  // phone: string;
  // Id: string | undefined;
  customerId?:string;
  salutation: string;
  firstName: string;
  lastName: string;
  companyName: string;
  displayName: string;
  email: string;
  phone?: string;
  address: {
    street: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
  };
  website: string;
  orgId: string;
  GSTIN: string;
  userType:string;
  updatedBy?:string;
  customerName?:string;
}

export const createUser = async (customerData: UserPayload) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/customers/addNewUser`, customerData, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.data; // Return the API response
  } catch (error: any) {
    console.error("Error creating user:", error.response || error.message);
    throw error; // Rethrow the error for the caller to handle
  }
};
export const getUsers = async (orgId: string,userType:string) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/customers/getUsers`, {
      params: { orgId,userType},
    });
    return response.data.data;
  } catch (error: any) {
    console.error("Error fetching users:"+userType, error?.response?.data?.message || error?.message);
      throw new Error("Failed to fetch "+userType,error?.response?.data?.message || error?.message);
    }
};
export const getUsersByOrgId = async (orgId: string) => {
  const url = `${BASE_URL}/api/customers/getUsersByOrgId?orgId=${orgId}`;
  try {
    const response = await axios.get(url);
    if (response.data.success) {
      return response.data.users;
    } else {
      throw new Error("Failed to fetch users.");
    }
  } catch (error) {
    console.error("Error fetching users:", error);
    throw error;
  }
};
  // Function to delete an item
  export const deleteUser = async (data: IUserRequest): Promise<IUpdateItemResponse> => {
    try {
        const response = await axios.put<IUpdateItemResponse>(`${BASE_URL}/api/customers/deleteUser`,data);
        return response.data;
      
    } catch (error: any) {
      console.error("Error deleting user:", error);
      throw new Error(error.response?.data?.message || "Failed to delete user");
    }
  };
    export const updateUser = async (data: UserPayload): Promise<IUpdateItemResponse> => {
      try { 
        data.updatedBy="sysAdmin";
        data.displayName=`${data.salutation} ${data.firstName} ${data.lastName}`
        const response = await axios.put(`${BASE_URL}/api/customers/updateUser`, data, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        return response.data;
      } catch (error: any) {
        console.error("Error updating user:", error.response || error.message);
        throw new Error(error.response?.data?.message || "Failed to update user");
      }
    };
    //getUsersByCustomerId
    export const getUsersByCustomerId = async (orgId: string,customerId:string) => {
      const url = `${BASE_URL}/api/customers/getUsersByCustomerId?orgId=${orgId}&customerId=${customerId}`;
      try {
        const response = await axios.get(url);
        if (response.data.success) {
          return response.data.users;
        } else {
          throw new Error("Failed to fetch user."+customerId);
        }
      } catch (error) {
        console.error("Error fetching users:", error);
        throw error;
      }
    };
    